import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaAws } from "react-icons/fa";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiGit,
  DiJava
} from "react-icons/di";
import {
  SiMongodb,
  SiApachekafka,
  SiSolidity,
  SiPostgresql,
  SiSpringboot,
  SiMysql,
  SiOpenai,SiLangchain,SiExpress
} from "react-icons/si";
import {
  GrGraphQl
} from "react-icons/gr";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <FaAws />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMongodb />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiApachekafka />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <SiOpenai />
      </Col>
        <Col xs={4} md={2} className="tech-icons">
        <SiLangchain />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
         <SiSpringboot />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
         <SiExpress />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact/>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSolidity />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <GrGraphQl />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
    </Row>
  );
}

export default Techstack;
